<footer class="page-footer" *transloco="let t">
  <div class="footer-container">
    <!-- About Section -->
    <div class="footer-column about-column">
      <h3 class="footer-title">{{ t('aboutQuestAtlas') }}</h3>
      <p class="footer-text">{{ t('aboutDescription') }}</p>
    </div>

    <!-- Quick Links Section -->
    <div class="footer-column links-column">
      <h3 class="footer-title">{{ t('quickLinks') }}</h3>
      <nav class="footer-links" aria-label="Quick links">
        <a [routerLink]="['/privacy-policy']" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ t('privacyPolicy') }}
        </a>
        <a [routerLink]="['/terms-and-conditions']" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ t('termsOfUse') }}
        </a>
        <a [href]="websiteLink" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ t('aboutUs') }}
        </a>
        <a [href]="websiteLink" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ t('blog') }}
        </a>
        <a [href]="websiteLink" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ t('support') }}
        </a>
        <a [href]="websiteLink" target="_blank" rel="noopener noreferrer" class="footer-link">
          {{ t('howItWorks') }}
        </a>
      </nav>
    </div>

    <!-- Social & Contact Section -->
    <div class="footer-column social-column">
      <h3 class="footer-title">{{ t('followUs') }}</h3>
      <div class="social-links">
        <a [href]="threadsLink" target="_blank" rel="noopener noreferrer" class="social-link" [attr.aria-label]="t('threads')">
          <svg class="social-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.321 6.016c-.27-.18-1.166-.802-1.166-.802.756-1.081 1.753-1.502 3.132-1.502.975 0 1.803.327 2.394.948s.928 1.509 1.005 2.644q.492.207.905.484c1.109.745 1.719 1.86 1.719 3.137 0 2.716-2.226 5.075-6.256 5.075C4.594 16 1 13.987 1 7.994 1 2.034 4.482 0 8.044 0 9.69 0 13.55.243 15 5.036l-1.36.353C12.516 1.974 10.163 1.43 8.006 1.43c-3.565 0-5.582 2.171-5.582 6.79 0 4.143 2.254 6.343 5.63 6.343 2.777 0 4.847-1.443 4.847-3.556 0-1.438-1.208-2.127-1.27-2.127-.236 1.234-.868 3.31-3.644 3.31-1.618 0-3.013-1.118-3.013-2.582 0-2.09 1.984-2.847 3.55-2.847.586 0 1.294.04 1.663.114 0-.637-.54-1.728-1.9-1.728-1.25 0-1.566.405-1.967.868ZM8.716 8.19c-2.04 0-2.304.87-2.304 1.416 0 .878 1.043 1.168 1.6 1.168 1.02 0 2.067-.282 2.232-2.423a6.2 6.2 0 0 0-1.528-.161" fill="currentColor"/>
          </svg>
        </a>
        <a [href]="instagramLink" target="_blank" rel="noopener noreferrer" class="social-link" [attr.aria-label]="t('instagram')">
          <svg class="social-icon" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" stroke-width="2"/>
            <circle cx="12" cy="12" r="4" stroke="currentColor" stroke-width="2"/>
            <circle cx="17.5" cy="6.5" r="1" fill="currentColor"/>
          </svg>
        </a>
      </div>

      <div class="contact-section">
        <h3 class="footer-title margin-top-24">{{ t('contactUs') }}</h3>
        <a [href]="'mailto:' + contactEmail" class="footer-link contact-link">
          {{ contactEmail }}
        </a>
      </div>
    </div>

    <!-- App Download Section -->
    @if (showAppDownload) {
      <div class="footer-column app-column">
        <h3 class="footer-title">{{ t('downloadOurApp') }}</h3>
        <div class="app-download-links">
          <a [href]="appStoreLink" target="_blank" rel="noopener noreferrer" class="app-store-link" [attr.aria-label]="'Download on the App Store'">
            <img style="width: 150px; height: 50px" src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg" alt="Download on the App Store"/>
          </a>
          <a [href]="playStoreLink" target="_blank" rel="noopener noreferrer" class="app-store-link" [attr.aria-label]="'Get it on Google Play'">
            <img style="width: 170px; height: 50px" src="assets/images/google-play-badge.svg" alt="Get it on Google Play"/>
          </a>
        </div>
      </div>
    }
  </div>

  <!-- Copyright Section -->
  <div class="footer-bottom">
    <p class="copyright-text">© {{ currentYear }} QuestAtlas. {{ t('allRightsReserved') }}</p>
  </div>
</footer>

